import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { CreateRetakeRequestInput, CreateRetakeRequestMutation } from '../queries/generated';
import { finalMap } from '../rx/final-map';

@Injectable({
  providedIn: 'root'
})
export class RetakeRequestsService {
  private readonly createRetakeRequestMutation = inject(CreateRetakeRequestMutation);

  create(input: CreateRetakeRequestInput) {
    return this.createRetakeRequestMutation.mutate({ input }).pipe(
      map(({ data }) => data.createRetakeRequest),
      finalMap('retakeRequest')
    );
  }
}
